module.exports = __webpack_public_path__ + "static/control_flames-162c079191d943c20f47af00f532d170.png";